exports = module.exports = require("../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, "._1LLM1M0QAXyBwg66iaexA9{margin:0 0 30px 0}._2eMOq1DUNWl4eEwFPRHuQY{padding:20px;background:#fff;box-shadow:1px 1px 8px rgba(0,0,0,0.15);border-radius:5px}._17JsKSDxucDHEjYoqRfoqX ._2eMOq1DUNWl4eEwFPRHuQY{padding:0 0}._2lrb5MjTjmjY46tCyDqjbQ{display:flex;align-items:center;justify-content:space-between}._2lrb5MjTjmjY46tCyDqjbQ h2{align-self:flex-end}._1aTc8TX7uApErOio9Dcc26{align-self:flex-start}._269S7uEBh-y50iOnvVLpiE{align-self:flex-end;margin-bottom:20px}\n", ""]);

// Exports
exports.locals = {
	"SectionBox": "_1LLM1M0QAXyBwg66iaexA9",
	"SectionContent": "_2eMOq1DUNWl4eEwFPRHuQY",
	"noPadding": "_17JsKSDxucDHEjYoqRfoqX",
	"flexHeader": "_2lrb5MjTjmjY46tCyDqjbQ",
	"flexLeft": "_1aTc8TX7uApErOio9Dcc26",
	"flexRight": "_269S7uEBh-y50iOnvVLpiE"
};